module.exports = __webpack_public_path__ + "media/images/illustration_1_764-b0958b01b510b6b027140f523555a34a.png";